(() => {
  const popup = document.getElementById('DarWelcomePopup');
  if (!popup) return;

  const STORAGE_KEY = 'darWelcomeDiscountPopupV1';
  const discountCode = popup.dataset.discountCode || 'BUNVENIT10';
  const delay = Number.parseInt(popup.dataset.delay || '1600', 10);
  const hideDays = Number.parseInt(popup.dataset.hideDays || '7', 10);
  const closeButtons = popup.querySelectorAll('[data-dar-popup-close]');
  const copyButton = popup.querySelector('[data-dar-copy-code]');
  const applyButton = popup.querySelector('[data-dar-apply-discount]');
  const dialog = popup.querySelector('[role="dialog"]');
  let lastFocusedElement = null;

  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  const forceOpen = new URLSearchParams(window.location.search).get('dar_popup') === '1';

  const rememberDismissal = () => {
    if (isDesignMode) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (error) {
      // The popup still works when storage is unavailable.
    }
  };

  const wasRecentlyDismissed = () => {
    if (forceOpen || isDesignMode) return false;

    try {
      const timestamp = Number.parseInt(window.localStorage.getItem(STORAGE_KEY) || '0', 10);
      if (!timestamp) return false;
      return Date.now() - timestamp < hideDays * 24 * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  };

  const openPopup = () => {
    lastFocusedElement = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('dar-popup-open');
    window.requestAnimationFrame(() => dialog && dialog.focus());
  };

  const closePopup = (remember = true) => {
    if (remember) rememberDismissal();
    popup.hidden = true;
    document.body.classList.remove('dar-popup-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  };

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup(true));
  });

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const originalLabel = copyButton.textContent;
      try {
        await copyText(discountCode);
        copyButton.textContent = 'Cod copiat ✓';
      } catch (error) {
        copyButton.textContent = discountCode;
      }

      window.setTimeout(() => {
        copyButton.textContent = originalLabel;
      }, 2200);
    });
  }

  if (applyButton) {
    applyButton.addEventListener('click', rememberDismissal);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup(true);
  });

  if (!wasRecentlyDismissed()) {
    window.setTimeout(openPopup, Number.isFinite(delay) ? delay : 1600);
  }
})();
